module.exports = __webpack_public_path__ + "media/images/icon/navigation/account-1a4df706d7afe93b75cd65c4ada32005.svg";